import {MDCTextField} from '@material/textfield';
import {MDCRipple} from '@material/ripple';
import Promise from 'promise-polyfill';
import 'whatwg-fetch';

if (!window.Promise) {
  window.Promise = Promise;
}

[].forEach.call(document.querySelectorAll('.mdc-text-field'), (tf) => {
  MDCTextField.attachTo(tf);
});

const ack = document.getElementById("ack");
const inputs = {
  message: document.getElementById('message'),
  email: document.getElementById('email')
};

const submitBtn = document.getElementById('submit');
const form = document.getElementById('contact-form');

form.addEventListener('submit', (e) => {
  e.preventDefault();
  const fields = {
    message: inputs.message.value,
    email: inputs.email.value,
  };
  submitBtn.className += " hidden";
  inputs.message.setAttribute('disabled', '');
  inputs.email.setAttribute('disabled', '');
  ack.textContent = 'Submitting...';
  submit(fields);
});

function submit(fields) {
  fetch('https://us-central1-upgear-io.cloudfunctions.net/upgeario-contact', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(fields)
  }).then(function(res) {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res;
  }).then(function(res) {
    ack.innerHTML = `We will get back to you<br>shortly at ${fields.email}!`;
    console.log("submitted successfully");
  }).catch(function(err) {
    ack.className += " error-text";
    ack.innerHTML = `Well this is embarrassing,<br>looks like we were unable<br>to process your submission.`;
    console.error(err);
  });
}
